import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { HomeBox } from "../components";
import calls from "apis/calls";

function Home() {
  const navigate = useNavigate();
  const checkwalletExist = async () => {
    let walletExist = await calls.wallet_exixt();

    if (walletExist) {
      // navigate("/dashboard");
    }
  };
  useEffect(() => {
    checkwalletExist();
  }, []);
  return (
    <>
      <div>
        <div className="bg-img-main">
          <div className="bg-img"></div>
        </div>

        {/* ========================Home-Banner===================  */}
        <section id="banner">
          <div className="custom-container">
            <div className="sec-padding">
              <div className="row">
                <div className="col-lg-12">
                  <div className="main">
                    <HomeBox />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Home;
